module.exports = __webpack_public_path__ + "75c1c88f64049e6cd2b9b6d9c31db8ef.png";